import {createModel} from '@@/package/utils/ModelUtil';
import {TaskModel} from "~~/package/mapper/learning/model/TaskModel";

export class ContestModel extends TaskModel {
    constructor(
        public lastAnswer: string[] = [],
        public taskTestTemplateId: number = 0,
        public submissionFlag: boolean = false
    ) {
        super();
    }

    public static override create(model: Partial<ContestModel>): ContestModel {
        return createModel<ContestModel>(ContestModel, {
            ...model
        });
    }
}
